import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ProductData, productDataSchema } from '@shared/types';
import { ViewEditDialog } from '@web/components/ui/view-edit-dialog';
import { ProductDetailsForm } from './products-details-form';

type ProductDetailsCardProps = {
  product: ProductData;
  onSubmit: (data: ProductData) => Promise<void>;
  onClose?: () => void;
};

export function ProductDetailsCard({
  product,
  onSubmit,
  onClose,
}: Readonly<ProductDetailsCardProps>) {
  const form = useForm<ProductData>({
    resolver: zodResolver(productDataSchema),

    defaultValues: product,
  });

  return (
    <ViewEditDialog
      title="Product Details"
      onSubmit={form.handleSubmit(onSubmit)}
      onClose={onClose}
      render={({ isEditMode, setIsSubmitting }) => (
        <ProductDetailsForm
          form={form}
          isEditMode={isEditMode}
          setIsSubmitting={setIsSubmitting}
          onSubmit={async (data) => {
            await onSubmit(data);
            onClose?.();
          }}
        />
      )}
    />
  );
}
